import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";
import mergeDeep from "../util/mergeDeep";

export default function sessionReducer(state = initialState.session, action) {
	switch (action.type) {
		case types.ACTIVE_ONDERNEMING_SET: {
			let stateToUpdate = mergeDeep({}, state);
			stateToUpdate.activeOrganisatieOndernemingsnummer = action.body.federatieOndernemingsnummer;
			stateToUpdate.activeOrganisatieId = action.body.federatieId;
			stateToUpdate.gebruikersnaam = action.body.gebruikersnaam;
			stateToUpdate.emailAdres = action.body.email;
			stateToUpdate.activeOrganisatieNaam = action.body.federatieNaam;
			return stateToUpdate;
		}

		case types.ACTIVE_SPORTCLUBID_SET: {
			let stateToUpdate = mergeDeep({}, state);
			stateToUpdate.activeSportclubId = action.body.sportclubId;
			stateToUpdate.activeTransactionId = action.body.transactionId;
			stateToUpdate.readOnly = action.body.readOnly;
			stateToUpdate.isNew = action.body.isNew;
			return stateToUpdate;
		}

		case types.ACTIVE_TRANSACTIONID_SET: {
			let stateToUpdate = mergeDeep({}, state);
			stateToUpdate.activeTransactionId = action.body;
			return stateToUpdate;
		}

		case types.USER_SESSION_MODEL_RECIEVED: {
			let stateToUpdate = mergeDeep({}, state);

			stateToUpdate.gebruikersnaam = action.body.gebruikersnaam;
			stateToUpdate.organisaties = action.body.organisaties;
			stateToUpdate.activeOrganisatieId = action.body.activeOrganisatieId;
			stateToUpdate.activeOrganisatieNaam = action.body.activeOrganisatieNaam;
			stateToUpdate.activeOrganisatieOndernemingsnummer = action.body.activeOrganisatieOndernemingsnummer;
			stateToUpdate.emailAdres = action.body.emailAdres;

			return stateToUpdate;
		}

		case types.SPORTCLUBSEARCHMODEL_SET: {
			let stateToUpdate = mergeDeep({}, state);

			stateToUpdate.sportclubSearchModel = action.body.sportclubSearchModel;

			return stateToUpdate;
		}

		case types.SET_UNSAVED_CHANGES: {
			let stateToUpdate = mergeDeep({}, state);

			stateToUpdate.hasUnsavedChanges = action.body;

			return stateToUpdate;
		}

		case types.ACTIVATE_SPORTORGANISATIE_POPUP_SHOWN: {
			let stateToUpdate = mergeDeep({}, state);

			stateToUpdate.activateSportorganisatiePopupShown = true;

			return stateToUpdate;
		}

		case types.RESET_ACTIVATE_SPORTORGANISATIE_POPUP_SHOWN: {
			let stateToUpdate = mergeDeep({}, state);

			stateToUpdate.activateSportorganisatiePopupShown = false;

			return stateToUpdate;
		}

		case types.USERTYPE_SET: {
			let stateToUpdate = mergeDeep({}, state);

			stateToUpdate.userType = action.body;

			return stateToUpdate;
		}

		case types.ACTIVE_ORGANISATIENIVEAU_SET: {
			let stateToUpdate = mergeDeep({}, state);
			stateToUpdate.activeOrganisatieNiveau = action.body;
			return stateToUpdate;
		}

		default:
			return state;
	}
}
